module.exports = __webpack_public_path__ + "img/breadcrumb-chevron-right.d8937db9.svg";